import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import { IMPORT_DIAGNOSTIC } from '../analytics.constants';

export const trackImportDiagnostic =
  (userId: string, analyticsTrack = track): AppThunk =>
  (_, getState) => {
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsTrack({
      name: IMPORT_DIAGNOSTIC,
      properties: {
        user_id: userId,
        view,
        ecg_id: ecgId,
        imported_diagnostic: userId,
        interaction: 'keyboard',
      },
    });
  };
